<template>
    <div class="control-visibility-rules">
        <div style="display:flex;align-items:center;justify-content:space-between">
            <div>
                <h6>Visibility / Conditional Logic</h6>
                <p class="hint">Define rules that control when this field is shown.</p>
            </div>
            <div>
                <button class="btn btn-sm" :class="{ 'btn-primary': visualMode }" @click="visualMode=true">Visual</button>
                <button class="btn btn-sm" :class="{ 'btn-primary': !visualMode }" @click="visualMode=false">JSON</button>
            </div>
        </div>

        <div v-if="visualMode">
            <ControlRuleBuilder :rules="localRuleObj" :availableFields="availableFields" @update:rules="onBuilderUpdate" />
        </div>

        <div v-else>
            <textarea v-model="jsonText" rows="8" class="form-control json-editor"></textarea>

            <div class="actions" style="margin-top:8px;">
                <button class="btn btn-sm btn-primary" @click="apply">Apply</button>
                <button class="btn btn-sm btn-secondary" @click="reset">Reset</button>
                <span v-if="error" class="text-danger" style="margin-left:8px">{{ error }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import ControlRuleBuilder from './ControlRuleBuilder'

export default {
    name: 'ControlVisibilityRules',
    components: { ControlRuleBuilder },
    props: {
        control: { type: Object, required: true },
        formData: { type: Object, required: false },
        availableFields: { type: Array, required: false, default: () => [] }
    },
    data() {
        const initialArray = (this.control && this.control.visibilityRules) || []
        const initialObj = (Array.isArray(initialArray) && initialArray[0]) || { joiner: 'OR', conditions: [] }
        return {
            jsonText: JSON.stringify(initialArray, null, 2),
            error: null,
            visualMode: true,
            localRuleObj: JSON.parse(JSON.stringify(initialObj))
        }
    },
    methods: {
        apply() {
            this.error = null
            try {
                const parsed = JSON.parse(this.jsonText)
                if (!Array.isArray(parsed)) throw new Error('Visibility rules must be an array of rule objects')
                // directly mutate control (sidebar saves clone later)
                this.$set(this.control, 'visibilityRules', parsed)
                // keep visual builder in sync with the first rule object
                this.localRuleObj = (parsed && parsed[0]) ? JSON.parse(JSON.stringify(parsed[0])) : { joiner: 'OR', conditions: [] }
            } catch (e) {
                this.error = e.message || 'Invalid JSON'
            }
        },
        reset() {
            const arr = this.control.visibilityRules || []
            this.jsonText = JSON.stringify(arr, null, 2)
            this.localRuleObj = (arr && arr[0]) ? JSON.parse(JSON.stringify(arr[0])) : { joiner: 'OR', conditions: [] }
            this.error = null
        },
        onBuilderUpdate(newObj) {
            // builder sent an updated rule object — update textarea JSON and control
            const clone = JSON.parse(JSON.stringify(newObj || { joiner: 'OR', conditions: [] }))
            const arr = [clone]
            const incomingJson = JSON.stringify(arr)
            const currentArr = this.control && Array.isArray(this.control.visibilityRules) ? this.control.visibilityRules : []
            const currentJson = JSON.stringify(currentArr)
            // only update if different to avoid infinite update loop between builder <-> watcher
            if (incomingJson !== currentJson) {
                this.localRuleObj = clone
                this.jsonText = JSON.stringify(arr, null, 2)
                this.$set(this.control, 'visibilityRules', arr)
            }
        },
    },
    watch: {
        'control.visibilityRules': {
            handler(n) {
                const arr = n || []
                const newJson = JSON.stringify(arr)
                // avoid overwriting local state if identical
                if (newJson === JSON.stringify([this.localRuleObj])) return
                this.jsonText = JSON.stringify(arr, null, 2)
                this.localRuleObj = (arr && arr[0]) ? JSON.parse(JSON.stringify(arr[0])) : { joiner: 'OR', conditions: [] }
            },
            deep: true
        }
    }
}
</script>

<style scoped>
.json-editor { width:100%; font-family: monospace; }
.hint { font-size: 12px; color: #6b7280 }
</style>
